import * as React from 'react';
import {GROUP} from '../../../constants/LabelConstants';
import {GroupDeleteProps} from '../../../types/mx/components';

class GroupDeleteView extends React.Component<GroupDeleteProps, {}> {

    renderDetail(group) {
        return <React.Fragment>
            <p>
                Estas a punto de eliminar el Grupo {group.value},&nbsp;
                los usuarios y solicitudes se desasociarán.
            </p>
            <p>
                Esta opción no se puede deshacer.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressDeleteConfirm, onPressClose) {
        return <React.Fragment><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>{GROUP.DELETE_GROUP_CANCEL_BUTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressDeleteConfirm}>{GROUP.DELETE_GROUP_CONFIRM_BUTON}</a></React.Fragment>;
    }

    render() {
        const {group, onPressDeleteConfirm, onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail(group)}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressDeleteConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default GroupDeleteView;